import { useRouteError, isRouteErrorResponse } from 'react-router-dom';
import { Button, Result } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';

export const RouteError = () => {
    const error = useRouteError();
    console.error(error);

    let errorMessage = 'An unexpected error has occurred.';
    if (isRouteErrorResponse(error)) {
        errorMessage = error.statusText || error.data?.message || errorMessage;
    } else if (error instanceof Error) {
        errorMessage = error.message;
    }

    return (
        <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4">
            <Result
                status="error"
                icon={<CloseCircleOutlined style={{ color: '#ff4d4f' }} />}
                title="Oops! Something went wrong"
                subTitle="We're sorry for the inconvenience. Please try refreshing the page."
                extra={[
                    <Button key="retry" onClick={() => window.location.reload()}>
                        Refresh Page
                    </Button>,
                    <Button key="home" type="primary" onClick={() => (window.location.href = '/')}>
                        Go Home
                    </Button>,
                ]}
            >
                {import.meta.env.DEV && (
                    <pre className="mt-4 overflow-auto rounded bg-gray-100 p-4 text-xs text-left max-w-lg mx-auto">
                        {errorMessage}
                    </pre>
                )}
            </Result>
        </div>
    );
};
